import { objectValuesTyped } from '@bos/utils';

import { AdvisorRoleV4 } from '../../../api/generated/cz.partners.pid.backofficegateway.pfsadvisordefinition';

export const ALL_ADVISOR_ROLES: AdvisorRoleV4[] =
	objectValuesTyped(AdvisorRoleV4);
